import {InteractiveBrowserCredential} from '@azure/identity';
import {BlobServiceClient} from '@azure/storage-blob';
import {fileType} from '../components/Files';

export const getStorageAcccountCredentials = (container: string) => {
    const accountName = import.meta.env.VITE_STORAGE_ACCOUNT_NAME;
    const defaultAzureCredential = new InteractiveBrowserCredential({
        redirectUri: import.meta.env.VITE_REDIRECT_URI,
        clientId: import.meta.env.VITE_CLIENT_ID,
        tenantId: import.meta.env.VITE_TENANT_ID,
    },);

    const blobServiceClient = new BlobServiceClient(`https://${accountName}.blob.core.windows.net`, defaultAzureCredential);
    const containerClient =
        blobServiceClient.getContainerClient(container);

    return {blobServiceClient, containerClient, accountName, container};
}

export const uploadFile = async (file: File, container: string) => {
    const {containerClient, accountName} =
        getStorageAcccountCredentials(container);
    
    const time = new Date().getTime();
    try {
        const blobName = `${time}-${file.name}`;
        const blockBlobClient =
            containerClient.getBlockBlobClient(blobName);
        const res = await blockBlobClient.uploadData(file)
        const fileUrl = `https://${accountName}.blob.core.windows.net/${container}/${blobName}`;
        return {fileUrl, blobName, res};
    } catch (error: any) {
        return {error: `Error uploading file: ${error.message}`};
    }
}

export const deleteFile = async (file: fileType, container: string) => {
    try {
        const {containerClient} =
            getStorageAcccountCredentials(container);
        const res = await containerClient.deleteBlob(file.blobName);
        return {res};
    } catch(error: any) {
        return {error: `Error deleting file: ${error.message}`};
    }
}